import { ContentHeaderService, ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import angular, { IScope } from 'angular';

function ContentHeaderDirective() {
  ContentHeaderController.$inject = ['$scope', 'ContentHeaderService'];

  function ContentHeaderController(
    $scope: IScope & { contentHeader: ContentHeaderService },
    ContentHeaderService: ContentHeaderService
  ) {
    $scope.contentHeader = ContentHeaderService;

    $scope.$on('contentHeader::startLoad', function () {
      $scope.contentHeader.isLoading = true;
    });
    $scope.$on('contentHeader::endLoad', function () {
      $scope.contentHeader.isLoading = false;
    });
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/contentHeader/contentHeader.tpl.html',
    scope: {},

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: ContentHeaderController,
  };
}

export const ContentHeaderDirectiveModule = angular
  .module('acme.common.directive.contentHeader', [ContentHeaderServiceModule])
  .directive('contentHeader', ContentHeaderDirective).name;
